import { render, staticRenderFns } from "./Expansion.vue?vue&type=template&id=ff5c2bf4&"
import script from "./Expansion.vue?vue&type=script&lang=js&"
export * from "./Expansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports